module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol/iterator.js
// module id = 267
// module chunks = 168707334958949